import { icons, LucideProps, Workflow } from 'lucide-react';

import TekstAppIcon from 'src/shared/components/ui/icons/tekst-app-icon';

export type Icons = keyof typeof icons | 'TekstAppIcon';

export interface DynamicIconProps extends LucideProps {
  name: Icons;
}

export default function DynamicIcon({ name, ...props }: DynamicIconProps) {
  if (!name) {
    return <Workflow key={name} {...props} />;
  }

  // custom icons
  if (name === 'TekstAppIcon') {
    return <TekstAppIcon {...props} />;
  }

  const LucideIcon = icons[name];
  if (LucideIcon) {
    return <LucideIcon {...props} />;
  }
  return <Workflow key={name} {...props} />;
}
